import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { AdaptiveSizeDrawer } from './config';
export function AdaptiveDrawer(props) {
    const { header, children, open } = props;
    return (_jsxs(AdaptiveSizeDrawer, { variant: "permanent", open: open, children: [header, _jsx(Box, { overflow: "auto", children: children })] }));
}
